import { useMemo } from 'react';
import { useIsDesktop } from '@reflex/ui/hooks/useIsDesktop';
import { filterContributionsByViewport } from '@/lib/plugin-registry';
import { usePlugins } from './usePlugins';

/**
 * Agent-surface subset of {@link usePlugins}: tabs and actions already
 * filtered for the current viewport. `usePlugins` stays viewport-agnostic
 * so admin / plugin-detail pages still list every contribution.
 */
export function useAgentPluginContributions() {
  const { agentTabs, agentActions, agentHeaderBadges } = usePlugins();
  const isDesktop = useIsDesktop();

  const visibleTabs = useMemo(
    () => filterContributionsByViewport(agentTabs, isDesktop),
    [agentTabs, isDesktop],
  );
  const visibleActions = useMemo(
    () => filterContributionsByViewport(agentActions, isDesktop),
    [agentActions, isDesktop],
  );

  return {
    agentTabs: visibleTabs,
    agentActions: visibleActions,
    agentHeaderBadges,
  };
}
